/* ==========================================================================
   claude 舞台 stage — 视频的加载、播放与暂停
   1. 进视口（可见 ≥ 20%）才给 <video> 设 src 并播放；离开视口、切到别的标签页就暂停。
   2. 暂停键：用户按了暂停就一直停着，直到再按播放（不因为重新进视口而恢复）。
   3. 系统开了减弱动效：不自动播放，显示静帧，按钮是「Play」；用户可以自己点播放。
   4. 桌面与手机各一个片源，首次播放及跨断点时按当前宽度选择；切源保留用户的暂停状态。
   不加 scroll 监听。
   ========================================================================== */

(function () {
  'use strict';

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var MOBILE = window.matchMedia('(max-width: 749px)');

  function initFilm(root) {
    var dialog = root.querySelector('[data-sg-dialog]');
    if (!dialog || root._sgFilmInit) return;
    root._sgFilmInit = true;
    var opener = root.querySelector('[data-sg-film-open]');
    var closer = dialog.querySelector('[data-sg-film-close]');
    var frame = dialog.querySelector('[data-sg-frame]');
    var tpl = dialog.querySelector('[data-sg-film-tpl]');
    function close() {
      if (!root._sgFilmOpen) return;
      root._sgFilmOpen = false;
      frame.textContent = '';
      if (dialog.open) dialog.close();
      root.dispatchEvent(new Event('sg:filmchange'));
      opener.focus({preventScroll:true});
    }
    function open() {
      if (root._sgFilmOpen) return;
      root._sgFilmOpen = true;
      root.dispatchEvent(new Event('sg:filmchange'));
      frame.appendChild(tpl.content.cloneNode(true));
      dialog.showModal();
      var video = frame.querySelector('video');
      if (video) video.play().catch(function () {});
    }
    function backdrop(e) { if (e.target === dialog) close(); }
    function cancel(e) { e.preventDefault(); close(); }
    opener.addEventListener('click',open);
    closer.addEventListener('click',close);
    dialog.addEventListener('cancel',cancel);
    dialog.addEventListener('close',close);
    dialog.addEventListener('click',backdrop);
    root._sgFilmTeardown = function () {
      close();
      opener.removeEventListener('click',open);
      closer.removeEventListener('click',close);
      dialog.removeEventListener('cancel',cancel);
      dialog.removeEventListener('close',close);
      dialog.removeEventListener('click',backdrop);
      delete root._sgFilmInit;
    };
  }

  function initStage(root) {
    if (!root || root._sgInit) return;
    initFilm(root);
    var video = root.querySelector('[data-sg-video]');
    if (!video) return;
    root._sgInit = true;

    var btn = root.querySelector('[data-sg-pause]');
    var txt = btn ? btn.querySelector('[data-sg-pause-text]') : null;
    var userPaused = RM.matches;
    var inView = false;
    var io = null;

    function label() {
      if (!btn) return;
      btn.setAttribute('data-sg-paused', userPaused ? 'true' : 'false');
      btn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
      if (txt) txt.textContent = userPaused ? btn.getAttribute('data-label-play') : btn.getAttribute('data-label-pause');
    }

    function ensureSrc() {
      var src = MOBILE.matches ? video.getAttribute('data-src-m') : video.getAttribute('data-src-d');
      if (!src || video.getAttribute('src') === src) return;
      root.removeAttribute('data-sg-playing');
      video.setAttribute('src', src);
      video.load();
    }

    function update() {
      var want = inView && !userPaused && !root._sgFilmOpen && !document.hidden;
      if (want) {
        ensureSrc();
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      } else if (!video.paused) {
        video.pause();
      }
    }

    function onPlaying() {
      if (!video.paused && video.readyState >= 2) root.setAttribute('data-sg-playing', '');
    }
    function onReset() { root.removeAttribute('data-sg-playing'); }
    function onBreakpoint() {
      if (video.getAttribute('src')) ensureSrc();
      update();
    }
    root.addEventListener('sg:filmchange', update);
    function onVisibility() { update(); }
    function onClick() { userPaused = !userPaused; label(); update(); }

    video.addEventListener('playing', onPlaying);
    video.addEventListener('emptied', onReset);
    video.addEventListener('error', onReset);
    MOBILE.addEventListener('change', onBreakpoint);
    document.addEventListener('visibilitychange', onVisibility);
    if (btn) btn.addEventListener('click', onClick);

    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        inView = entries[entries.length - 1].isIntersecting;
        update();
      }, { threshold: 0.2 });
      io.observe(root);
    } else {
      inView = true;
      update();
    }
    label();

    root._sgTeardown = function () {
      root.removeEventListener('sg:filmchange', update);
      if (io) io.disconnect();
      video.removeEventListener('playing', onPlaying);
      video.removeEventListener('emptied', onReset);
      video.removeEventListener('error', onReset);
      MOBILE.removeEventListener('change', onBreakpoint);
      document.removeEventListener('visibilitychange', onVisibility);
      if (btn) btn.removeEventListener('click', onClick);
      if (!video.paused) video.pause();
      root.removeAttribute('data-sg-playing');
      delete root._sgInit;
      delete root._sgTeardown;
    };
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-sg-root]');
    for (var i = 0; i < roots.length; i++) initStage(roots[i]);
  }

  function rootOf(t) { return t && t.querySelector ? t.querySelector('[data-sg-root]') : null; }

  document.addEventListener('shopify:section:load', function (e) { initStage(rootOf(e.target)); });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = rootOf(e.target);
    if (root && root._sgFilmTeardown) root._sgFilmTeardown();
    if (root && root._sgTeardown) root._sgTeardown();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
